import { InvoiceImportErrorCode } from '../Types/invoiceImport.types';
import { getErrorMessage } from './errorCodeMapping';

/**
 * Stable codes returned by InvoiceImportValidationPolicy
 * (TravelCRM.Application.InvoiceImport.Contracts.InvoiceImportValidationIssueCodes).
 */
const VALIDATION_ISSUE_MESSAGES: Record<string, string> = {
  validationMissingRequiredField: 'Brakuje wymaganego pola w odczytanej fakturze.',
  validationLowFieldConfidence: 'Niska pewność odczytu OCR dla wymaganego pola.',
  validationTotalsMismatch: 'Suma netto i VAT nie zgadza się z podaną kwotą brutto.',
  validationInvalidSupplierTaxId: 'NIP dostawcy nie ma poprawnego formatu (10 cyfr).',
  validationNoLineItems: 'Faktura nie zawiera żadnych pozycji.',
  validationInvalidLineItemAmount: 'Jedna z pozycji ma ujemną ilość lub cenę jednostkową.',
};

/**
 * Backend failure issues set `code` to the raw C# InvoiceImportErrorCode member name
 * (InvoiceImportProcessor: `Code = errorCode.ToString()`), which is PascalCase — unlike the
 * camelCase InvoiceImportErrorCode values used everywhere else in the contract. Lower-casing the
 * first character bridges the two without duplicating all 15 messages.
 */
const toCamelCase = (value: string): string =>
  value.length === 0 ? value : value.charAt(0).toLowerCase() + value.slice(1);

const KNOWN_ERROR_CODES = new Set<string>(Object.values(InvoiceImportErrorCode));

/**
 * Resolves a stable, allowlisted Polish message for a structured issue code (RM-07): raw
 * backend/provider text is never rendered directly, only a code-derived message from this
 * allowlist or the generic fallback for an unrecognized code.
 */
export function getImportIssueMessage(code: string): string {
  const validationMessage = VALIDATION_ISSUE_MESSAGES[code];
  if (validationMessage) {
    return validationMessage;
  }

  const camelCased = toCamelCase(code);
  if (KNOWN_ERROR_CODES.has(camelCased)) {
    return getErrorMessage(camelCased as InvoiceImportErrorCode);
  }

  return getErrorMessage(InvoiceImportErrorCode.Unknown);
}
